import { ButtonSkeleton, TableSkeleton } from '@/components/shared/skeleton'

export const FeedSummarySkeleton = () => (
  <div className="flex flex-col">
    <div className="mb-32 flex justify-between">
      <ButtonSkeleton width={190} />
      <ButtonSkeleton width={100} />
    </div>
    <TableSkeleton rows={3} />
  </div>
)
